<template>
    <div class="row ml-xl-4 m-0">              
        <div class="col-md-12  table-responsive scroll-table" v-if="listadoParcelasUsuario.length > 0">
            <table class="mt-3 table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th class="text-center">{{ $t('parcelas.n_parcela') }}</th>
                        <th class="text-center">{{ $t('perfil.zona') }}</th>
                        <th class="text-center">{{ $t('perfil.precio') }}</th>
                        <th class="text-center">{{ $t('parcelas.user') }}</th>
                        <th class="text-center">{{ $t('gracias.descargar_pdf') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(parcela, index) in listadoParcelasUsuario">
                        <tr :key="index">
                            <td class="text-center">{{ parcela.parcela_numero }}</td>
                            <td class="text-center">{{ parcela.zona.nombre }}</td>
                            <td class="text-center">{{ parcela.parcela_ticket.price }}€</td>
                            <td class="text-center">{{ parcela.user.name }}</td>
                            <td class="text-center">
                                <a :href="parcela.pdf_url" target="_blank" class="btn btn-primary">
                                    PDF
                                </a>
                            </td>
                        </tr>
                    </template>                    
                </tbody>
            </table>
        </div>
        <div class="col-md-12 col-sm-8" v-else>
            <p class="mt-2">{{ $t('parcelas.sin_parcelas') }}</p>
        </div>
    </div>    
</template>
<script>
    export default {
        props:['user_id'],
        data() {
            return {
                listadoParcelasUsuario: [],
                listadoParcelas: [],
            }
        },
        methods: {
            async getListadoParcelas() {
                if (!this.$store.getters.getListaAbonados?.id) {
                    this.$toast.error("No se ha encontrado una lista de abonados");
                    return;
                }

                const params = {
                    lista_id: this.$store.getters.getListaAbonados?.id,
                };
                
                try {
                    const response = await this.$store.dispatch('BACK_LISTADO_PARCELAS_VENDIDAS', params);
                    this.listadoParcelas = response.data.data;

                    this.listadoParcelas.forEach(pedido => {
                        const parcelasDelUsuario = pedido.parcelas.filter(parcela => {
                            return parcela.user && parcela.user.id === this.user_id;
                        });
                        this.listadoParcelasUsuario.push(...parcelasDelUsuario);
                    });
                } 
                catch (error) {
                    this.$toast.error("Error al obtener el listado de parcelas: " + (error.message || ""));
                    this.listadoParcelas = { data: [] };
                }
            }
        },
        created() {
            this.getListadoParcelas();
        }
    }
</script>